<template>
    <div class="card">
        <h5 class="mt-2 ml-4">Comentários</h5>
        <div class="card-body">
            <div class="d-flex">
                <div class="mr-3 sidebar-img-user">
                    <img class="fotoColab" :src="fotoColaboradorPerfil" alt="" width="55" style="border-radius: 50px;">
                </div>
                <textarea type="text" class="form-control w-100" rows="4" style="border-radius: 20px;"
                    v-model="dsObservacao" placeholder="Insira um comentário">
                        </textarea>
            </div>
            <button class="btn btn-success mt-3" style="margin-left: 8vh" @click="enviarObservacao">Salvar</button>
            <button class="btn  mt-3 ml-3" @click="dsObservacao = ''">Cancelar</button>

            <div v-if="exibeComentariosFeitos">
                <div class="d-flex align-items-start mt-5" v-for="(comentario, index) in arrayComentarios" :key="index">
                    <div class="mr-3 sidebar-img-user">
                        <img class="fotoColab" :src="fotoColaborador(comentario)" alt="" width="55"
                            style="border-radius: 50px;">
                    </div>
                    <div>
                        <span>{{ comentario.g_clifor.ds_colaborador }} - </span>
                        <span style="font-size: 13px">{{ comentario.created_at | formatDate("DD/MM/YYYY HH:mm:ss")
                            }}</span><br>
                        <span>{{ comentario.ds_observacao }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            dsObservacao: '',
            observacaoTemp: '',
            exibeComentariosFeitos: true,
            arrayComentarios: []
        }
    },  
    props: {
        os: {},
    },
    computed: {
        arrayComentarios2() {
            return this.os.comentarios
        },
        fotoColaboradorPerfil(){
            const fotoColaborador = this.$store.getters['filial/filial']

            if(!fotoColaborador.foto){
                return
            }
            return 'https://ginfo.inovess.com.br/cadastros/colab/arquivoscolab/' + fotoColaborador.foto
        }
      
    },

    created(){
        // if(this.os.comentarios.lenght > 0){
            this.exibeComentariosFeitos = true
            this.arrayComentarios = this.os.comentarios
        // }

    },  
    methods: {
        fotoColaborador(comentario) {
        // const fotoColaborador = this.$store.getters['filial/filial']if()
            if(comentario.g_clifor.foto){
                return 'https://ginfo.inovess.com.br/cadastros/colab/arquivoscolab/' + comentario.g_clifor.foto
            } else {
                return 

            }
        }, 

        getFormattedDate() {
            const now = new Date();
            
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0'); // Meses começam do zero
            const day = String(now.getDate()).padStart(2, '0');
            
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            const milliseconds = String(now.getMilliseconds()).padStart(3, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
        },

        enviarObservacao(){
            const filial = this.$store.getters['filial/filial']
            const data = {
                ds_observacao: this.dsObservacao,
                nr_seq_clifor: filial.tecnicoId,
                nr_seq_os: this.$route.params.id,
                created_at: this.getFormattedDate(),
                g_clifor: {} 
            }

            data.g_clifor.foto = filial.foto
            data.g_clifor.ds_colaborador = filial.dsColaborador

            this.$store.dispatch('osItemExecucao/enviaObservacao', { data: data }).then(response => {
                this.exibeComentariosFeitos = true
                this.arrayComentarios.push(data)
                this.dsObservacao = ''
          })
        }
    }
}
</script>